import algoliasearch from 'algoliasearch/lite'

export default (() => {

  $('.js-search-input').each(function() {
    const input = $(this);
    const wrapper = input.parents('.js-search-wrapper');
    const resetButton = wrapper.find('.js-search-reset');
    const submitButton = wrapper.find('.js-search-submit');
    const $results = input.siblings( '.js-results' )

    const client = algoliasearch( '73KTR2Z38I', '87cca4306480ba9115ae1869f44bd9f6' )
    const index = client.initIndex( 'general' )

    const toggleClearButton = () => {

      if(input.val() != '') {
        submitButton.attr("disabled", false);
        resetButton.addClass('active');
        input.addClass('active');
      } else {
        submitButton.attr("disabled", true);
        resetButton.removeClass('active');
        input.removeClass('active');
        $results.html( '' )
      }
    }

    toggleClearButton();

    input.on('focus', function() {
      $(this).select();
    });

    input.on('keyup focus', function() {
      searchIndex( this.value )
      toggleClearButton();
    });

    $(document).on('click', function(e){
      var $tgt = $(e.target);
      if(!$tgt.is($results) && !$tgt.is($('*', $results)) && !$tgt.is(input) ){
        $results.removeClass( 'has-term' )
      }
    })

    let searchIndex = async ( term ) => {

      if(input.data('no-suggests') == '1') {
        return;
      }

      // Enable loading state
      $results.addClass( 'is-loading' )

      if ( term ) {
        let results = ( await index.search(term, {
          attributesToRetrieve: ['title', 'url', 'document__url', 'status', 'course__courseCode', 'type'],
          attributesToHighlight: ['title'],
          filters: '(status:"live") AND (start_ts >= ' + Math.floor(Date.now() / 1000) + ')',
          hitsPerPage: 5
        }) ).hits
        $results.addClass( 'has-term' )

        let template = ''
        if ( results.length ) {
          results.forEach( result => {
            let courseCode = result.hasOwnProperty('course__courseCode') ? ' (' + result.course__courseCode + ')' : '';
            template += `<div class="c-result"><a class="c-result__link" href="${ (result.type == 'Document' ? result.document__url : result.url) }">${ result._highlightResult.title.value }${ courseCode }</a><span class="c-result__type">(${ result.type })</span></div>`
          } )
        } else {
          template = 'No results found.'
        }

        $results.html( template )
      } else {

        $results.removeClass( 'has-term' )
      }


      $results.removeClass( 'is-loading' )
    }

    resetButton.on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      resetButton.removeClass('active');
      input.val('').focus();
      $results.removeClass( 'has-term' )
      toggleClearButton();
    });

  });

})()
